import { svg } from 'lit';

const symbol = svg`<svg width="13" height="17" xmlns="http://www.w3.org/2000/svg"><g stroke="#4E4E4E" fill="none" fill-rule="evenodd"><path d="M3.929 1.452H.987v15h11.077v-15z"/><path stroke-linecap="square" d="M3.5 4.5h6M5.5 7.5h4M5.5 9.5h4M5.5 11.5h4M5.5 13.5h4"/></g></svg>`;

export { symbol as default };
